import { ImpactType } from './units';

export const emptyImpactTotals = (): Record<ImpactType, number> => ({
  [ImpactType.TREES]: 0,
  [ImpactType.CARBON_OFFSETS]: 0,
  [ImpactType.CARBON_REMOVAL]: 0,
  [ImpactType.HABITAT_RESTORATION]: 0,
});
